import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axiosInstance from "../../axios";
import { Loading } from "../Other/Loading";
import EnterprisePayment from "./EnterprisePayment";
import OverlayContainer from "@components/Overlay/OverlayContainer";

const CurrentSubscription = () => {
  const { loggedIn } = useSelector((state) => state.authentication);
  const subscriptionStatusInfo = useSelector((state) => state.authentication);
  const [subscriptionDetails, setSubscriptionDetails] = useState();
  const [response, setResponse] = useState();
  const [popUp, setPopUP] = useState(false);
  const [statusLoading, setStatusLoading] = useState(false);
  const [userSelectedPlan, setUserSelectedPlan] = useState(null);
  const [downGradeStatus, setDownGradeStatus] = useState(null);
  useEffect(() => {
    const fetchSubscriptionDetails = async () => {
      if (loggedIn) {
        setResponse(true);
        try {
          const res = await axiosInstance.get("/current-subscription");
          setSubscriptionDetails(res?.data?.data);
        } catch (error) {
          console.error("Error fetching subscription details:", error.message);
        } finally {
          setResponse(false);
        }
      }
    };

    fetchSubscriptionDetails();
  }, [loggedIn]);


  useEffect(() => {
    if (subscriptionStatusInfo?.token?.subscriptionStatus === 0) {
      setPopUP(true);
    }
  }, []);
  return (
    <>
      <section className="container-wrapper">
        {response ? (
          <Loading />
        ) : (
          <div
            className="main studentPurchase"
            style={{ height: "auto", border: "1px solid black" }}
          >
            <div className="content">
              <div className="content-inner">
                <div className="inner-top">
                  <div className="inner-top-flex plan-Details">
                    <div className="right studentname webinarDetails plan_header">
                      <h3>Plan Info</h3>
                    </div>
                  </div>
                  <div className="plan-flex">
                    <div className="inner-top-flex plan-Details">
                      <div
                        className="right studentname webinarDetails"
                        style={{ color: "#264b82" }}
                      >
                        <span> Plan Name:</span>{" "}
                        {subscriptionDetails?.planInfo?.name}
                      </div>
                    </div>
                    <div className="inner-top-flex plan-Details">
                      <p
                        className="courseNameResponsive webinarDetails"
                        style={{ color: "#264b82" }}
                      >
                        <span>Plan Value :</span>{" "}
                        {subscriptionDetails?.planInfo?.amount}
                      </p>
                    </div>

                    <div className="inner-top-flex plan-Details">
                      <p
                        className="courseNameResponsiveAgain webinarDetails"
                        style={{ color: "#264b82" }}
                      >
                        <span> Remaining Credits:</span>
                        {subscriptionDetails?.subscribed?.availableCredit.toFixed(
                          2
                        )}
                      </p>
                    </div>

                    <div className="inner-top-flex plan-Details">
                      <p
                        className="courseNameResponsiveAgain webinarDetails"
                        style={{ color: "#264b82" }}
                      >
                        <span> Remaining Days:</span>{" "}
                        {subscriptionDetails?.remainingDays}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
      {popUp && (
        <div className="enterPrise-PaymentOption">
          <EnterprisePayment
            setPopUP={setPopUP}
            setStatusLoading={setStatusLoading}
            changedSelectedPlan={userSelectedPlan}
            setDownGradeStatus={setDownGradeStatus}
          />
        </div>
      )}
    </>
  );
};
export default CurrentSubscription;
